import React, { useEffect, useState } from 'react';
import SectionPlayList from '../Item/SectionPlayList';
import { db } from '../../firebase';
import Loading from './Loading';
import { useHistory } from 'react-router-dom';

function HomePage(props) {

    const [loadingPage, setLoadingPage] = useState(true);
    const [listCategories, setListCategories] = useState([]);

    let history = useHistory();
    useEffect(() => {

        db.collection("categories").where("status", "==", true)
            .get()
            .then(function (querySnapshot) {
                setListCategories(querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
                setTimeout(() => {
                    setLoadingPage(false);
                }, 300);
            })
            .catch(function (error) {
                console.log("Error getting categories.");
                history.push('/error');
            });

        return () => {
            clearTimeout();
        }

    }, []);

    return (
        <div className="Root__right-container__scroll" >
            <div className="Root__right-container__section--wrap">
                {listCategories.map((item, index) => (<SectionPlayList key={index} item={item} />))}
            </div>
            <Loading loadingPage={loadingPage} />
        </div >
    );
}

export default HomePage;